import {
  CrmDocumentSignerRejectionFragment,
  DocumentRegisterSignerRejectionFragment,
  SignerInfoRejectionFragment,
  SignerRejectionFragment,
} from "gql/graphql";
import Text from "@/shared/typography/text";
import { TextWithShowMore } from "@/shared/typography/text-with-show-more";
import { DateTimeFormatter } from "@/shared/formatters";
import { useTranslations } from "use-intl";

export function SignerRejection({
  data,
}: {
  data:
    | SignerRejectionFragment
    | DocumentRegisterSignerRejectionFragment
    | CrmDocumentSignerRejectionFragment
    | SignerInfoRejectionFragment;
}) {
  const t = useTranslations("SignSignature");

  if (!data.rejectedDate) {
    return null;
  }

  const comment = "rejectionComment" in data ? data.rejectionComment : null;

  return (
    <div data-testid={"signer-rejection"}>
      <Text type={"caption"} color={"secondary"}>
        {t.rich("Rejected at <date></date>", {
          date: () => <DateTimeFormatter value={new Date(data.rejectedDate)} />,
        })}
      </Text>

      {comment && <TextWithShowMore>{comment}</TextWithShowMore>}
    </div>
  );
}
